module.exports = __webpack_public_path__ + "img/shape3.b9027ccf.svg";